import { fetch } from '@ixigo/shell/fetch';

import type { PaymentStatusResponse } from '../types';

export function fetchPaymentStatus(
	transactionId: string,
): Promise<PaymentStatusResponse> {
	return fetch
		.get(`payments/v4/express/callback/${transactionId}`)
		.json<{ data: PaymentStatusResponse }>()
		.then((response) => response.data);
}
